import { Component, Input, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { Drink } from 'src/interfaces/drink.model';
import { LocalizationService } from 'src/app/services/localization.service';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash-es';
import { Subject, takeUntil } from 'rxjs';
import { BasketService } from 'src/app/services/basket.service';
import { DataService } from 'src/app/services/data.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { MenuDrinkRecomendationDialogComponent } from '../menu-drink-recomendation-dialog/menu-drink-recomendation-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { Locale } from 'src/interfaces/locale.model';
import { NO_PHOTO } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-menu-recomendation-card-drink',
    templateUrl: './menu-recomendation-card-drink.component.html',
    styleUrls: ['./menu-recomendation-card-drink.component.css'],
    standalone: false
})
export class MenuRecomendationCardDrinkComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private basketService: BasketService,
    private dataService: DataService, 
    public localization: LocalizationService,
    private imageCache: ImageCacheService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.basketDrinks = [];
    this.locale = this.dataService.locale;

    // Получаем ширину экрана
    this.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.vw = Math.min(this.vw, 480);
  }

  @Input() drink!: Drink;

  locale: Locale | null = null;

  // Подписываемся на изменения корзины
  private destroy$ = new Subject<void>();
  private basketDrinks: Drink[];
  
  // Получаем ширину экрана
  private vw: number;
  width: number = 220;
  height: number = 100;

  // Изображение заглушка
  imageSrc: string = NO_PHOTO.drink;

  ngOnInit(): void {
    this.basketService.drinks
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: Drink[]) => {
      this.basketDrinks = data;
    });

    // Image
    if (this.drink?.image?.trim()) {
      this.imageCache.getImage(this.drink.image, NO_PHOTO.drink).then(src => {
        this.imageSrc = src;
      });
    }
  }

  ngAfterViewInit() {
    this.width = (Math.min(this.vw || 480) - 18) / 1.6;
    this.height = this.width * 0.40;
    this.cdr.detectChanges(); // Обновляем Angular-поток изменений
  }

  handleClick(event: MouseEvent): void {
    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#717075');
    this.cdr.detectChanges(); // Обновляем Angular-поток изменений

    const basketDrink = this.getBasketDrink();
    const dialogRef = this.dialog.open(MenuDrinkRecomendationDialogComponent,
      sheetDialogConfig(basketDrink ? cloneDeep(basketDrink) : cloneDeep(this.drink)));

    dialogRef.afterClosed().subscribe(() => {
      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');
      this.cdr.detectChanges(); // Обновляем Angular-поток изменений
    });

    event.stopPropagation();
  }

  getBasketDrink(): Drink | null {
    return this.basketDrinks.find(f => f.id === this.drink.id) || null;
  }

  ngOnDestroy(): void {
    // Отписка при уничтожении компонента
    this.destroy$.next();
    this.destroy$.complete();}
}